// Line icons from the approved Hub mockups (24 px grid, stroke = currentColor). Decorative: aria-hidden.
import type { ReactElement, SVGProps } from "react";

type IconProps = { size?: number } & Omit<SVGProps<SVGSVGElement>, "width" | "height">;

function line(paths: ReactElement, extra: SVGProps<SVGSVGElement> = {}) {
  return function Icon({ size = 18, ...rest }: IconProps) {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}
        strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" {...extra} {...rest}>
        {paths}
      </svg>
    );
  };
}

export const IconToday = line(<path d="M4 10.5 12 4l8 6.5V20h-5v-6h-6v6H4z" />);
export const IconWaste = line(<path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13" />);
export const IconMarkets = line(<path d="M3 10h18l-2-5H5zM5 10v10h14V10" />);
export const IconHousing = line(<path d="M3 11 12 4l9 7M5 10v10h14V10" />);
export const IconBus = line(<><rect x="4" y="4" width="16" height="13" rx="3" /><path d="M4 11h16M8 20l1-3M16 20l-1-3" /></>);
export const IconFire = line(
  <path d="M12 21c4 0 7-2.7 7-6.8 0-3.7-2.6-6.3-4.3-8.2-.4 2.3-1.6 3.6-2.9 4.3C12 7.4 10.6 5 9 3.5 8.7 7 5 9.6 5 14.2 5 18.3 8 21 12 21z" />,
);
export const IconHeadset = line(
  <><path d="M4 13a8 8 0 0 1 16 0" /><rect x="3" y="13" width="4" height="6" rx="1.5" /><rect x="17" y="13" width="4" height="6" rx="1.5" /></>,
);
export const IconCard = line(<><rect x="3" y="5.5" width="18" height="13" rx="2.5" /><path d="M3 10h18" /></>);
export const IconPeople = line(
  <><circle cx="9" cy="8.5" r="3.5" /><path d="M2.5 20c1-3.4 3.6-5 6.5-5s5.5 1.6 6.5 5M16 4.5a3.5 3.5 0 0 1 0 7M18.5 15c1.6.6 2.7 2.3 3 5" /></>,
);
export const IconPlace = line(<><path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z" /><circle cx="12" cy="9.5" r="2.5" /></>);
export const IconSettings = line(
  <><circle cx="12" cy="12" r="3" /><path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" /></>,
);
export const IconSearch = line(<><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></>, { strokeWidth: 2.4 });
export const IconBell = line(<><path d="M6 16V11a6 6 0 0 1 12 0v5l2 2H4z" /><path d="M10 20.5a2 2 0 0 0 4 0" /></>);
export const IconClose = line(<path d="M6 6l12 12M18 6 6 18" />, { strokeWidth: 2.4 });
export const IconChevron = line(<path d="m9 6 6 6-6 6" />, { strokeWidth: 2.4 });
export const IconMenu = line(<path d="M4 7h16M4 12h16M4 17h16" />);
export const IconSignOut = line(<path d="M15 4h4v16h-4M10 8l-4 4 4 4M6 12h10" />);

/** The Smart City map mark (filled, on the black brand tile). */
export function SmartCityMark({ size = 20 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
      <path d="M3 6.5 9 4l6 2.5L21 4v13.5L15 20l-6-2.5L3 20z" />
    </svg>
  );
}
